export const enum UserStatus {
  NEW = 1,
  ACTIVE = 2,
  BLOCKED = 3,
}

export enum SectionTypes {
  Dynamic = 1,
  Static = 2,
  StaticPlus = 3,
}

export const enum Role {
  STUDENT = 'STUDENT',
  ASSISTANT = 'ASSISTANT',
  TEACHER = 'TEACHER',
}

export const enum FileFolders {
  UserProfile = 'user/profile',
  VideoComments = 'videos-comments',
  Images = 'images',
  Courses = 'courses',
  Posts = 'posts',
  Vacancy = 'vacancy',
  OurTeam = 'our-team',
}

export const enum DataStatus {
  ACTIVE = 1,
  INACTIVE = 2,
  ARCHIVED = 3,
}

export const enum SocketEvents {
  VideoUpdate = 'video_update',
  VideoReload = 'video_reload',
  VideoUpdateProgress = 'video_update_progress',
}

export const enum Statuses {
  Active = 'active',
  Archived = 'archived',
}

export const enum PostType {
  News = 'news',
  Blogs = 'blog',
  Event = 'event',
}

export const enum BlogsType {
  Recommend = 1,
  Top,
}

export const enum LanguageAlphabet {
  UZ = 'uz',
  RU = 'kr',
  CYRL = 'cyrl',
  LATIN = 'latin',
}

export const enum Language {
  UZ = 1,
  EN,
}
